// 基础参数
const baseParam = {
  'page_id': 0,
  'url': '',
  // 'ts': Date.now(),
  // 'ts_offset': 0,
  'uid': 0,
  'passport_id': 0,
  'app_id': 24,
  'device_id': 'web',
  'sn': '',
  'net': '',
  'mno': '',
  'app_system': 'web',
  'app_runtime': 'native', // 客户端执行环境
  'app_version': '1.0',
  'city_id': 0,
  'type': 1, // 访问“1”，点击“2”，
  'event': 1, // 数据类型 埋点“1”
  'os': 'pc',
  'os_version': '',
  'device_type': 'PC', // 数据接收服务
  'latitude': '',
  'longitude': ''
}
export default baseParam



// WEBPACK FOOTER //
// ./src/tracer/baseParam.js